var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlumniGradCap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M68.87,106.52v35.67h82.34V106.52S112.87,85.86,68.87,106.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M189.71,93.19l-79-51-80.3,51,26.5,17.67V97c56.83-26.69,106.34,0,106.34,0v13.86Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "44.71 103.52 44.71 153.52 37.87 184.85 53.37 184.85 45.04 153.19"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlumniGradCap);
export default __webpack_public_path__ + "static/media/ALUMNI_GRAD_CAP.319a21baa17b611d320f872ebfca522b.svg";
export { ForwardRef as ReactComponent };